export default "__VITE_ASSET__BG4ESb49__"